import { createFileRoute } from "@tanstack/react-router";
import { callscreeningQueryOptions } from "@/server/callscreening";
import { CallScreening } from "@/components/call-screening";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { checkIfUserMayWrite, CrudEntry } from "@/lib/utils";

export const Route = createFileRoute("/_dashboard/callscreening/system")({
  component: RouteComponent,
  loader: ({ context }) => {
    return {
      crumb: "System",
      userProfileId: (context as { user?: { profile: string } }).user?.profile,
      accessControl: (context as { user?: { accessControl: Record<string, CrudEntry> } }).user?.accessControl,
    };
  },
});

function RouteComponent() {
  const { userProfileId, accessControl } = Route.useLoaderData();
  const mayWrite = checkIfUserMayWrite(userProfileId, accessControl, "CALL_SCREENING");
  const systemRuleSetQuery = useQuery(callscreeningQueryOptions);

  useEffect(() => {
    if (systemRuleSetQuery.isError) {
      const message =
        systemRuleSetQuery.error instanceof Error
          ? systemRuleSetQuery.error.message
          : "Failed to load system rule set. Please try again later.";
      toast.error(message);
    }
  }, [systemRuleSetQuery.isError, systemRuleSetQuery.error]);

  return (
    <CallScreening
      callscreeningData={systemRuleSetQuery.data}
      resourceType="system"
      loading={systemRuleSetQuery.isLoading}
      mayWrite={mayWrite}
    />
  );
}
